export default __webpack_public_path__ + "static/media/bullets-2.e529c410.gif";